import React, { useState, useEffect, useRef } from 'react';
import { celebrationsService } from '../services/celebrationsService';

// =====================================================
// GVC CELEBRATIONS DISPLAY - For Dedicated Raspberry Pi
// Premium SVG icons for luxury appearance
// =====================================================

// =====================================================
// PREMIUM SVG ICONS
// =====================================================
const Icons = {
  Trophy: ({ size = 50, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 15C8.68629 15 6 12.3137 6 9V3H18V9C18 12.3137 15.3137 15 12 15Z" fill={color} stroke={color} strokeWidth="1.5"/>
      <path d="M6 5H3V8C3 9.65685 4.34315 11 6 11V5Z" fill={color} stroke={color} strokeWidth="1.5"/>
      <path d="M18 5H21V8C21 9.65685 19.6569 11 18 11V5Z" fill={color} stroke={color} strokeWidth="1.5"/>
      <path d="M9 21H15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 15V21" stroke={color} strokeWidth="2"/>
      <circle cx="12" cy="8" r="2" fill="white"/>
    </svg>
  ),
  
  Cake: ({ size = 50, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 16V21H20V16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 16C4 14 6 12 12 12C18 12 20 14 20 16" stroke={color} strokeWidth="2"/>
      <path d="M4 16H20" stroke={color} strokeWidth="2"/>
      <rect x="6" y="12" width="12" height="4" fill={color} opacity="0.3"/>
      <path d="M8 12V9" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 12V8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 12V9" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="8" cy="7" r="1.5" fill={color}/>
      <circle cx="12" cy="6" r="1.5" fill={color}/>
      <circle cx="16" cy="7" r="1.5" fill={color}/>
    </svg>
  ),
  
  GoldMedal: ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="14" r="7" fill="url(#goldGradient)" stroke="#B8860B" strokeWidth="1.5"/>
      <path d="M9 3L12 8L15 3" stroke="#B8860B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 10V18" stroke="#B8860B" strokeWidth="1" opacity="0.5"/>
      <path d="M8 14H16" stroke="#B8860B" strokeWidth="1" opacity="0.5"/>
      <text x="12" y="16" textAnchor="middle" fill="#8B4513" fontSize="6" fontWeight="bold">1</text>
      <defs>
        <linearGradient id="goldGradient" x1="5" y1="7" x2="19" y2="21">
          <stop offset="0%" stopColor="#FFD700"/>
          <stop offset="50%" stopColor="#FFA500"/>
          <stop offset="100%" stopColor="#FFD700"/>
        </linearGradient>
      </defs>
    </svg>
  ),
  
  SilverMedal: ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="14" r="7" fill="url(#silverGradient)" stroke="#808080" strokeWidth="1.5"/>
      <path d="M9 3L12 8L15 3" stroke="#808080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <text x="12" y="16" textAnchor="middle" fill="#4A4A4A" fontSize="6" fontWeight="bold">2</text>
      <defs>
        <linearGradient id="silverGradient" x1="5" y1="7" x2="19" y2="21">
          <stop offset="0%" stopColor="#E8E8E8"/>
          <stop offset="50%" stopColor="#C0C0C0"/>
          <stop offset="100%" stopColor="#E8E8E8"/>
        </linearGradient>
      </defs>
    </svg>
  ),
  
  BronzeMedal: ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="14" r="7" fill="url(#bronzeGradient)" stroke="#8B4513" strokeWidth="1.5"/>
      <path d="M9 3L12 8L15 3" stroke="#8B4513" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <text x="12" y="16" textAnchor="middle" fill="#5D3A1A" fontSize="6" fontWeight="bold">3</text>
      <defs>
        <linearGradient id="bronzeGradient" x1="5" y1="7" x2="19" y2="21">
          <stop offset="0%" stopColor="#CD853F"/>
          <stop offset="50%" stopColor="#CD7F32"/>
          <stop offset="100%" stopColor="#CD853F"/>
        </linearGradient>
      </defs>
    </svg>
  ),
  
  Balloon: ({ size = 28, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="12" cy="10" rx="6" ry="8" fill={color}/>
      <ellipse cx="10" cy="8" rx="1.5" ry="2" fill="white" opacity="0.4"/>
      <path d="M12 18L10 22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 18L14 22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10 18C10 18 11 19 12 18C13 17 14 18 14 18" stroke={color} strokeWidth="1" strokeLinecap="round"/>
    </svg>
  ),
  
  Calendar: ({ size = 22, color = '#6b7280' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M3 10H21" stroke={color} strokeWidth="2"/>
      <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="15" r="2" fill={color}/>
    </svg>
  ),
  
  Star: ({ size = 20, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
    </svg>
  ),
  
  Phone: ({ size = 18, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="2" width="14" height="20" rx="3" stroke={color} strokeWidth="2"/>
      <circle cx="12" cy="18" r="1" fill={color}/>
      <path d="M9 5H15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  
  CheckCircle: ({ size = 16, color = '#22c55e' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill={color}/>
      <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  Clock: ({ size = 16, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
      <path d="M12 6V12L16 14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  
  Clipboard: ({ size = 80, color = '#9ca3af' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="4" width="14" height="17" rx="2" stroke={color} strokeWidth="1.5"/>
      <path d="M9 2H15V4C15 4.55228 14.5523 5 14 5H10C9.44772 5 9 4.55228 9 4V2Z" fill={color}/>
      <path d="M8 10H16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 14H13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  
  Gift: ({ size = 60, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="8" width="18" height="4" rx="1" fill={color}/>
      <rect x="5" y="12" width="14" height="9" fill={color} opacity="0.7"/>
      <path d="M12 8V21" stroke="white" strokeWidth="2"/>
      <path d="M12 8C12 8 9 8 7 6C5 4 7 2 9 3C11 4 12 8 12 8Z" stroke={color} strokeWidth="2" fill="none"/>
      <path d="M12 8C12 8 15 8 17 6C19 4 17 2 15 3C13 4 12 8 12 8Z" stroke={color} strokeWidth="2" fill="none"/>
    </svg>
  ),
  
  Crown: ({ size = 24, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M2 8L6 14L12 6L18 14L22 8L20 20H4L2 8Z"/>
      <circle cx="12" cy="4" r="1.5"/>
      <circle cx="4" cy="7" r="1"/>
      <circle cx="20" cy="7" r="1"/>
    </svg>
  ),
  
  Sparkle: ({ size = 20, color = '#F59E0B' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L13.5 9L20 12L13.5 15L12 22L10.5 15L4 12L10.5 9L12 2Z"/>
    </svg>
  )
};

const CelebrationsDisplay = () => {
  const [displayData, setDisplayData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [confettiActive, setConfettiActive] = useState(false);
  const tickerRef = useRef(null);

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @keyframes scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.02); }
      }
      @keyframes bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
      @keyframes fall {
        0% { transform: translateY(-100vh) rotate(0deg); opacity: 1; }
        100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
      }
      @keyframes glow {
        0%, 100% { box-shadow: 0 0 20px rgba(245,158,11,0.5); }
        50% { box-shadow: 0 0 40px rgba(245,158,11,0.8); }
      }
      @keyframes shimmer {
        0% { opacity: 0.7; }
        50% { opacity: 1; }
        100% { opacity: 0.7; }
      }
    `;
    document.head.appendChild(styleSheet);
    return () => document.head.removeChild(styleSheet);
  }, []);

  useEffect(() => {
    fetchDisplayData();
    const interval = setInterval(fetchDisplayData, 15000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (displayData?.todayBirthdays?.length > 0) {
      setConfettiActive(true);
      const timer = setTimeout(() => setConfettiActive(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [displayData?.todayBirthdays]);

  const fetchDisplayData = async () => {
    try {
      const data = await celebrationsService.getDisplay();
      setDisplayData(data);
    } catch (err) {
      console.error('Error fetching display data:', err);
      setDisplayData({ contest: null, leaderboard: [], birthdays: [], todayBirthdays: [], settings: {} });
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (date) => date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  const formatDate = (date) => date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

  const formatBirthdayDate = (dateStr) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const getDaysUntilBirthday = (dateStr) => {
    const today = new Date();
    const bday = new Date(dateStr + 'T00:00:00');
    bday.setFullYear(today.getFullYear());
    if (bday < today) bday.setFullYear(today.getFullYear() + 1);
    return Math.ceil((bday - today) / (1000 * 60 * 60 * 24));
  };

  const getContestDaysRemaining = () => {
    if (!displayData?.contest?.end_date) return null;
    const endDate = new Date(displayData.contest.end_date + 'T23:59:59');
    return Math.ceil((endDate - new Date()) / (1000 * 60 * 60 * 24));
  };

  if (loading) {
    return (
      <div style={styles.loadingScreen}>
        <img src="/gvc-logo.png" alt="GVC" style={{ height: 120 }} />
        <h1 style={styles.loadingText}>Loading Celebrations...</h1>
      </div>
    );
  }

  const settings = displayData?.settings || {};
  const contest = displayData?.contest;
  const leaderboard = displayData?.leaderboard || [];
  const birthdays = displayData?.birthdays || [];
  const todayBirthdays = displayData?.todayBirthdays || [];
  const daysRemaining = getContestDaysRemaining();

  const contestUrl = 'https://gvcbus.com/contest';
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(contestUrl)}&bgcolor=ffffff&color=000000`;

  return (
    <div style={styles.container}>
      {confettiActive && <ConfettiOverlay />}
      
      <div style={styles.header}>
        <div style={styles.headerCenter}>
          <img src="/gvc-logo.png" alt="GVC School Bus" style={styles.logo} />
          <div style={styles.headerText}>
            <div style={styles.companyName}>{settings.display_name || 'GVC Celebrations'}</div>
            <div style={styles.tagline}>Recognizing Our Amazing Team</div>
          </div>
        </div>
        <div style={styles.timeSection}>
          <div style={styles.time}>{formatTime(currentTime)}</div>
          <div style={styles.date}>{formatDate(currentTime)}</div>
        </div>
      </div>

      <div style={styles.mainContent}>
        {/* Contest Panel */}
        <div style={styles.panel}>
          <div style={styles.panelHeader}>
            <Icons.Trophy size={50} color="#92400e" />
            <div>
              <div style={styles.panelTitle}>{settings.contest_title || 'Google Reviews Contest'}</div>
              {contest && (
                <div style={styles.contestInfo}>
                  {daysRemaining > 0 ? `${daysRemaining} days remaining` : 'Contest ended!'}
                </div>
              )}
            </div>
          </div>
          
          <div style={styles.leaderboardContainer}>
            {leaderboard.length > 0 ? (
              leaderboard.slice(0, 5).map((entry, index) => (
                <LeaderboardEntry key={entry.id} entry={entry} rank={index + 1} />
              ))
            ) : (
              <div style={styles.emptyState}>
                <Icons.Clipboard size={80} color="#9ca3af" />
                <div style={{ fontSize: 32, color: '#6b7280', marginTop: 20 }}>
                  No participants yet!
                </div>
                <div style={{ fontSize: 24, color: '#9ca3af', marginTop: 10 }}>
                  Scan the QR code to register!
                </div>
              </div>
            )}
          </div>

          <div style={styles.bottomSection}>
            <div style={styles.prizesSection}>
              <div style={styles.prizeItem}>
                <Icons.GoldMedal size={36} />
                <span style={styles.prizeText}>{contest?.prize_1st || 'TBD'}</span>
              </div>
              <div style={styles.prizeItem}>
                <Icons.SilverMedal size={30} />
                <span style={styles.prizeText}>{contest?.prize_2nd || 'TBD'}</span>
              </div>
              <div style={styles.prizeItem}>
                <Icons.BronzeMedal size={26} />
                <span style={styles.prizeText}>{contest?.prize_3rd || 'TBD'}</span>
              </div>
            </div>
            
            <div style={styles.qrSection}>
              <div style={styles.qrBox}>
                <img src={qrCodeUrl} alt="Scan to Register" style={styles.qrCode} />
              </div>
              <div style={styles.qrText}>
                <div style={styles.qrTitle}>
                  <Icons.Phone size={18} color="#F59E0B" />
                  <span style={{ marginLeft: 8 }}>SCAN TO JOIN!</span>
                </div>
                <div style={styles.qrUrl}>gvcbus.com/contest</div>
              </div>
            </div>
          </div>
        </div>

        {/* Birthday Panel */}
        <div style={styles.panel}>
          <div style={styles.panelHeader}>
            <Icons.Cake size={50} color="#92400e" />
            <div>
              <div style={styles.panelTitle}>{settings.birthday_title || 'Happy Birthday!'}</div>
              <div style={styles.contestInfo}>
                {todayBirthdays.length > 0 
                  ? <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Icons.Balloon size={20} color="#92400e" />
                      {todayBirthdays.length} birthday{todayBirthdays.length > 1 ? 's' : ''} today!
                    </span>
                  : 'Celebrating our team'}
              </div>
            </div>
          </div>

          <div style={styles.birthdayContainer}>
            {todayBirthdays.length > 0 && (
              <div style={styles.todayBirthdaySection}>
                {todayBirthdays.map(birthday => (
                  <TodayBirthdayCard key={birthday.id} birthday={birthday} />
                ))}
              </div>
            )}

            {birthdays.filter(b => !todayBirthdays.find(tb => tb.id === b.id)).length > 0 && (
              <div style={styles.upcomingSection}>
                <div style={styles.upcomingTitle}>
                  <Icons.Calendar size={22} color="#6b7280" />
                  <span style={{ marginLeft: 8 }}>Upcoming</span>
                </div>
                {birthdays
                  .filter(b => !todayBirthdays.find(tb => tb.id === b.id))
                  .slice(0, 4)
                  .map(birthday => (
                    <UpcomingBirthdayRow key={birthday.id} birthday={birthday} formatBirthdayDate={formatBirthdayDate} getDaysUntilBirthday={getDaysUntilBirthday} />
                  ))}
              </div>
            )}

            {birthdays.length === 0 && todayBirthdays.length === 0 && (
              <div style={styles.emptyState}>
                <Icons.Balloon size={80} color="#d1d5db" />
                <div style={{ fontSize: 32, color: '#6b7280', marginTop: 20 }}>
                  No birthdays scheduled
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={styles.tickerContainer}>
        <div style={styles.tickerContent} ref={tickerRef}>
          <TickerContent todayBirthdays={todayBirthdays} contest={contest} leaderboard={leaderboard} />
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.footerLeft}>GVC School Bus - Precious Cargo Since 1991</div>
        <div style={styles.footerCenter}>
          <Icons.Star size={20} color="#FBBF24" />
          <span style={{ margin: '0 12px' }}>Scan QR Code or visit gvcbus.com/contest</span>
          <Icons.Star size={20} color="#FBBF24" />
        </div>
        <div style={styles.footerRight}>Powered by SVT Consulting</div>
      </div>
    </div>
  );
};

const LeaderboardEntry = ({ entry, rank }) => {
  const getMedalIcon = (rank) => {
    if (rank === 1) return <Icons.GoldMedal size={50} />;
    if (rank === 2) return <Icons.SilverMedal size={50} />;
    if (rank === 3) return <Icons.BronzeMedal size={50} />;
    return (
      <div style={{ 
        width: 50, height: 50, borderRadius: '50%', 
        background: '#e5e7eb', display: 'flex', 
        alignItems: 'center', justifyContent: 'center',
        fontSize: 24, fontWeight: 'bold', color: '#374151'
      }}>
        {rank}
      </div>
    );
  };

  return (
    <div style={styles.leaderboardEntry}>
      {getMedalIcon(rank)}
      <div style={styles.entryInfo}>
        <div style={styles.entryName}>{entry.first_name} {entry.last_name}</div>
        <div style={styles.entryStats}>
          {entry.verified_reviews > 0 && (
            <span style={styles.statBadge}>
              <Icons.CheckCircle size={14} color="#22c55e" />
              <span style={{ marginLeft: 4 }}>{entry.verified_reviews} verified</span>
            </span>
          )}
          {entry.pending_reviews > 0 && (
            <span style={{ ...styles.statBadge, background: '#fef3c7', color: '#92400e' }}>
              <Icons.Clock size={14} color="#f59e0b" />
              <span style={{ marginLeft: 4 }}>{entry.pending_reviews} pending</span>
            </span>
          )}
        </div>
      </div>
      <div style={styles.reviewCount}>
        <div style={styles.reviewNumber}>{entry.verified_reviews || 0}</div>
        <div style={styles.reviewLabel}>reviews</div>
      </div>
    </div>
  );
};

const TodayBirthdayCard = ({ birthday }) => (
  <div style={styles.todayBirthdayCard}>
    <Icons.Gift size={60} color="#F59E0B" />
    <div style={styles.birthdayName}>{birthday.employee_name}</div>
    {birthday.message && <div style={styles.birthdayMessage}>{birthday.message}</div>}
    <div style={styles.todayBadge}>
      <Icons.Sparkle size={24} color="#F59E0B" />
      <span style={{ margin: '0 8px' }}>TODAY!</span>
      <Icons.Sparkle size={24} color="#F59E0B" />
    </div>
  </div>
);

const UpcomingBirthdayRow = ({ birthday, formatBirthdayDate, getDaysUntilBirthday }) => {
  const daysUntil = getDaysUntilBirthday(birthday.birthday_date);
  
  return (
    <div style={styles.upcomingRow}>
      <Icons.Balloon size={28} color="#F59E0B" />
      <div style={styles.upcomingInfo}>
        <div style={styles.upcomingName}>{birthday.employee_name}</div>
        <div style={styles.upcomingDate}>{formatBirthdayDate(birthday.birthday_date)}</div>
      </div>
      <div style={styles.daysUntil}>
        {daysUntil === 1 ? 'Tomorrow!' : `${daysUntil} days`}
      </div>
    </div>
  );
};

const TickerContent = ({ todayBirthdays, contest, leaderboard }) => {
  const messages = [];
  
  todayBirthdays.forEach(b => {
    messages.push(`HAPPY BIRTHDAY ${b.employee_name.toUpperCase()}!`);
    if (b.message) messages.push(`${b.employee_name}: ${b.message}`);
  });
  
  if (contest) {
    messages.push(`${contest.name} - Scan the QR code to join!`);
    if (leaderboard.length > 0) {
      messages.push(`Current Leader: ${leaderboard[0].first_name} ${leaderboard[0].last_name} with ${leaderboard[0].verified_reviews || 0} reviews!`);
    }
  }
  
  if (messages.length === 0) {
    messages.push('GVC School Bus - Precious Cargo Since 1991');
    messages.push('Thank you for being part of our team!');
  }

  const tickerText = messages.join('     ★     ');
  
  return <div style={styles.tickerText}>{tickerText}     ★     {tickerText}</div>;
};

const ConfettiOverlay = () => {
  const confettiPieces = Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 3,
    duration: 3 + Math.random() * 2,
    color: ['#f59e0b', '#fbbf24', '#fcd34d', '#22c55e', '#3b82f6', '#f97316'][Math.floor(Math.random() * 6)]
  }));

  return (
    <div style={styles.confettiOverlay}>
      {confettiPieces.map(piece => (
        <div
          key={piece.id}
          style={{
            ...styles.confettiPiece,
            left: `${piece.left}%`,
            backgroundColor: piece.color,
            animationDelay: `${piece.delay}s`,
            animationDuration: `${piece.duration}s`
          }}
        />
      ))}
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    width: '100vw',
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    color: '#1f2937',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  loadingScreen: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 40,
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
  },
  loadingText: { color: '#f59e0b', fontSize: 48 },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 40px',
    background: 'linear-gradient(135deg, #FCD34D 0%, #FBBF24 100%)',
    borderBottom: '4px solid #F59E0B',
    position: 'relative'
  },
  headerCenter: { display: 'flex', alignItems: 'center', gap: 24 },
  logo: { height: 80 },
  headerText: { textAlign: 'left' },
  companyName: { fontSize: 42, fontWeight: 700, color: '#1f2937' },
  tagline: { fontSize: 20, color: '#374151', letterSpacing: 1 },
  timeSection: { position: 'absolute', right: 40, textAlign: 'right' },
  time: { fontSize: 64, fontWeight: 700, letterSpacing: -2, color: '#1f2937' },
  date: { fontSize: 24, color: '#374151' },
  mainContent: { flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, padding: 24, minHeight: 0 },
  panel: {
    background: 'white',
    borderRadius: 20,
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '20px 28px',
    background: 'linear-gradient(135deg, #FCD34D 0%, #FBBF24 100%)',
    borderBottom: '3px solid #F59E0B'
  },
  panelTitle: { fontSize: 32, fontWeight: 600, color: '#1f2937' },
  contestInfo: { fontSize: 18, color: '#374151', marginTop: 4 },
  leaderboardContainer: { flex: 1, padding: 20, display: 'flex', flexDirection: 'column', gap: 12, overflow: 'auto' },
  leaderboardEntry: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '14px 18px',
    background: '#f9fafb',
    borderRadius: 12,
    border: '2px solid #e5e7eb'
  },
  entryInfo: { flex: 1 },
  entryName: { fontSize: 24, fontWeight: 500, color: '#1f2937' },
  entryStats: { display: 'flex', gap: 8, marginTop: 6 },
  statBadge: {
    background: '#dcfce7',
    color: '#166534',
    padding: '3px 10px',
    borderRadius: 16,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center'
  },
  reviewCount: { textAlign: 'center' },
  reviewNumber: { fontSize: 40, fontWeight: 700, color: '#f59e0b' },
  reviewLabel: { fontSize: 14, color: '#6b7280' },
  bottomSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    background: '#f9fafb',
    borderTop: '2px solid #e5e7eb',
    gap: 24
  },
  prizesSection: { display: 'flex', flexDirection: 'column', gap: 6 },
  prizeItem: { display: 'flex', alignItems: 'center', gap: 8 },
  prizeText: { fontSize: 20, fontWeight: 600, color: '#92400e' },
  qrSection: { display: 'flex', alignItems: 'center', gap: 16 },
  qrBox: { background: 'white', padding: 8, borderRadius: 12, border: '3px solid #f59e0b', animation: 'glow 2s infinite' },
  qrCode: { width: 100, height: 100, display: 'block' },
  qrText: { textAlign: 'left' },
  qrTitle: { fontSize: 18, fontWeight: 700, color: '#f59e0b', marginBottom: 4, display: 'flex', alignItems: 'center' },
  qrUrl: { fontSize: 14, color: '#6b7280' },
  birthdayContainer: { flex: 1, padding: 20, display: 'flex', flexDirection: 'column', gap: 16, overflow: 'auto' },
  todayBirthdaySection: { display: 'flex', flexDirection: 'column', gap: 12 },
  todayBirthdayCard: {
    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    borderRadius: 16,
    padding: '24px 32px',
    textAlign: 'center',
    border: '3px solid #f59e0b',
    animation: 'pulse 2s infinite'
  },
  birthdayName: { fontSize: 36, fontWeight: 700, color: '#92400e', marginTop: 12 },
  birthdayMessage: { fontSize: 22, color: '#a16207', marginTop: 8, fontStyle: 'italic' },
  todayBadge: { marginTop: 12, fontSize: 26, fontWeight: 700, color: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'bounce 1s infinite' },
  upcomingSection: { marginTop: 16 },
  upcomingTitle: { fontSize: 22, color: '#6b7280', marginBottom: 12, display: 'flex', alignItems: 'center' },
  upcomingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    background: '#f9fafb',
    borderRadius: 10,
    marginBottom: 8,
    border: '1px solid #e5e7eb'
  },
  upcomingInfo: { flex: 1 },
  upcomingName: { fontSize: 20, fontWeight: 500, color: '#1f2937' },
  upcomingDate: { fontSize: 16, color: '#6b7280' },
  daysUntil: { fontSize: 18, color: '#f59e0b', fontWeight: 600 },
  emptyState: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
  tickerContainer: { background: 'linear-gradient(90deg, #F59E0B, #FBBF24, #F59E0B)', padding: '12px 0', overflow: 'hidden', position: 'relative' },
  tickerContent: { display: 'flex', animation: 'scroll 30s linear infinite' },
  tickerText: { whiteSpace: 'nowrap', fontSize: 24, fontWeight: 600, color: '#1f2937', paddingLeft: '100%' },
  footer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 40px', background: 'rgba(0,0,0,0.8)', borderTop: '2px solid #f59e0b' },
  footerLeft: { fontSize: 20, color: '#94a3b8' },
  footerCenter: { fontSize: 20, fontWeight: 500, color: '#fbbf24', display: 'flex', alignItems: 'center' },
  footerRight: { fontSize: 16, color: '#64748b' },
  confettiOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 100 },
  confettiPiece: { position: 'absolute', top: -20, width: 12, height: 12, borderRadius: '50%', animation: 'fall linear forwards' }
};

export default CelebrationsDisplay;
